export default "__VITE_ASSET__BVZJJhRH__"